import { createContext } from 'react';
import { CookieConsent } from '@/helpers/cookieConsent';

export interface ConsentContextValue {
  /** הבחירה התקפה, או null כל עוד המשתמש לא בחר. */
  consent: CookieConsent | null;
  /** האם הבאנר צריך להיות על המסך - טרם הוחלט, או נפתח מחדש מקישור. */
  isNoticeOpen: boolean;
  /** מאפשר למשתמש לחזור לבחירה שכבר עשה. */
  openNotice: () => void;
  /** סוגר באנר שנפתח מחדש בלי לשנות דבר. לא עושה כלום לפני בחירה ראשונה. */
  closeNotice: () => void;
  /** רושם בחירה ומיד מפעיל או עוצר את כלי המדידה בהתאם. */
  decide: (analytics: boolean) => void;
  /** האם כלי מדידה רץ בעמוד הזה - הבאנר מזהיר אז שחזרה מהסכמה תטען מחדש. */
  isAnalyticsRunning: () => boolean;
}

const ConsentContext = createContext<ConsentContextValue | null>(null);

export default ConsentContext;
